import React from 'react';

const Footer = () => {
  return (
    <footer className="site-footer" id="contact">
      <div className="container footer-content">
        <div>
          <h4 className="footer-title">Cineflix</h4>
          <p className="footer-text">Private celebration theatres across Bangalore.</p>
        </div>
        <div className="footer-actions">
          <a href="tel:+918088397071" className="footer-link">
            <i className="bi bi-telephone-fill" />
            +91 80883 97071
          </a>
          <a
            href="https://wa.me/918088397071"
            className="footer-link"
            target="_blank"
            rel="noreferrer"
          >
            <i className="bi bi-whatsapp" />
            Chat on WhatsApp
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
